import React, { useEffect } from "react";
import * as Icons from "react-feather";
import { Link, useNavigate, useParams } from "react-router-dom";
import Steps from "./Steps";
import InitInfo from "./Forms/InitInfo";
import { useWizard } from "store/wizard";
import ProductDetail from "./Forms/ProductDetail";
import CafeProductDetail from "./Forms/CafeProductDetail";
import PhysicalProductDetail from "./Forms/PhysicalProductDetail";
import Additional from "./Forms/Additional";
import Counting from "./Forms/Counting";
import ScreeningCounting from "./Forms/ScreeningCounting";
import Summery from "./Forms/Summery";
import PhysicalSummery from "./Forms/PhysicalSummery";
import Seasons from "./Forms/Seasons";
import ProductCatalogAccess from "./ProductCatalogAccess";

const CATALOG_PRODUCT_TYPES = [
  "Movie",
  "Serie",
  "Music",
  "Screening",
  "SerieEpisode",
];

// components

export default function Wizard(props) {
  const { id } = useParams();
  const wizard = useWizard();
  const navigator = useNavigate();

  useEffect(() => {
    if (id) {
      wizard.dispatch(wizard.getProductInfo(id));
    }
    return () => wizard.dispatch(wizard.reset());
  }, []);

  const mapSubmits = {
    // فیلم ها
    Movie1: (values) => {
      wizard.dispatch(
        wizard.submitBaseInfo(values, (data) => {
          navigator(`/products/wizard/${data.id}`);
          wizard.dispatch(wizard.next());
        })
      );
    },
    Movie2: (values) => {
      wizard.dispatch(
        wizard.submitDetail(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    Movie3: (values) => {
      wizard.dispatch(
        wizard.submitMedia(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    Movie4: (values) => {
      wizard.dispatch(
        wizard.submitCounting(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    // سریال ها
    Serie1: (values) => {
      wizard.dispatch(
        wizard.submitBaseInfo(values, (data) => {
          navigator(`/products/wizard/${data.id}`);
          wizard.dispatch(wizard.next());
        })
      );
    },
    Serie2: (values) => {
      wizard.dispatch(
        wizard.submitDetail(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    Serie4: (values) => {
      wizard.dispatch(
        wizard.submitMedia(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    //   موزیک ها
    Music1: (values) => {
      wizard.dispatch(
        wizard.submitBaseInfo(values, (data) => {
          navigator(`/products/wizard/${data.id}`);
          wizard.dispatch(wizard.next());
        })
      );
    },
    //   قسمتی از سریال
    SerieEpisode1: (values) => {
      wizard.dispatch(
        wizard.submitBaseInfo(values, (data) => {
          navigator(`/products/wizard/${data.id}`);
          wizard.dispatch(wizard.next());
        })
      );
    },
    SerieEpisode2: (values) => {
      wizard.dispatch(
        wizard.submitDetail(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    SerieEpisode3: (values) => {
      wizard.dispatch(
        wizard.submitMedia(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    SerieEpisode4: (values) => {
      wizard.dispatch(
        wizard.submitCounting(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    //   اکران ها
    Screening1: (values) => {
      wizard.dispatch(
        wizard.submitBaseInfo(values, (data) => {
          navigator(`/products/wizard/${data.id}`);
          wizard.dispatch(wizard.next());
        })
      );
    },
    Screening2: (values) => {
      wizard.dispatch(
        wizard.submitDetail(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    Screening3: (values) => {
      wizard.dispatch(
        wizard.submitMedia(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    Screening4: (values) => {
      wizard.dispatch(
        wizard.submitCounting(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    //   اکران در کافه 
    CafeScreening1: (values) => {
      wizard.dispatch(
        wizard.submitBaseInfo(values, (data) => {
          navigator(`/products/wizard/${data.id}`);
          wizard.dispatch(wizard.next());
        })
      );
    },
    CafeScreening2: (values) => {
      wizard.dispatch(
        wizard.submitDetail(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    CafeScreening3: (values) => {
      wizard.dispatch(
        wizard.submitMedia(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    CafeScreening4: (values) => {
      wizard.dispatch(
        wizard.submitCounting(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
    Physical1: (values) => {
      wizard.dispatch(
        wizard.submitBaseInfo(values, (data) => {
          navigator(`/products/wizard/${data.id}`);
          wizard.dispatch(wizard.next());
        })
      );
    },
    Physical2: (values) => {
      wizard.dispatch(
        wizard.submitPhysicalDetail(values, id, (data) => {
          wizard.dispatch(wizard.next());
        })
      );
    },
   
  };

  const mapRenders = {
    Movie1: <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Movie2: (
      <ProductDetail submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    Movie3: <Additional submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Movie4: <Counting submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Movie5: <Summery submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Serie1: <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Serie2: (
      <ProductDetail submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    Serie3: <Seasons submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Serie4: <Additional submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Serie5: <Summery submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Music1: <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />,
    SerieEpisode1: (
      <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    SerieEpisode2: (
      <ProductDetail submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    SerieEpisode3: (
      <Additional submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    SerieEpisode4: (
      <Counting submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    SerieEpisode5: (
      <Summery submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    Screening1: <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Screening2: (
      <ProductDetail submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    Screening3: (
      <Additional submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    Screening4: <Counting submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Screening5: <Summery submitStep={mapSubmits[wizard.type + wizard.step]} />,

    CafeScreening1: <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />,
    CafeScreening2: (
      <CafeProductDetail submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    CafeScreening3: (
      <Additional submitStep={mapSubmits[wizard.type + wizard.step]} />
    ),
    CafeScreening4: <ScreeningCounting submitStep={mapSubmits[wizard.type + wizard.step]} />,
    CafeScreening5: <Summery submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Physical1: <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Physical2: <PhysicalProductDetail submitStep={mapSubmits[wizard.type + wizard.step]} />,
    Physical3: <PhysicalSummery submitStep={mapSubmits[wizard.type + wizard.step]} />,
    
    Download1: <InitInfo submitStep={mapSubmits[wizard.type + wizard.step]} />,
  };

  return (
    <>
      <div className="content">
        <div className="w-full p-3 flex justify-between items-center">
          <h2>ایجاد محصول</h2>
          <button
            onClick={() => navigator(-1)}
            className="btn btn-info shadow-md mr-2"
          >
            بازگشت
          </button>
        </div>
        <hr className="my-3" />
        <div className="p-3 w-full gap-x-2">
          <div className="box py-8 sm:py-8">
            <div className="px-5 sm:px-20  border-gray-200 dark:border-dark-5">
              <Steps />
              {mapRenders[wizard.type + wizard.step]}
              {CATALOG_PRODUCT_TYPES.includes(wizard.type) && (
                <ProductCatalogAccess productId={id} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
